import { ref } from "vue";
import { Channel } from "../services/channel";

export function createAreasChannel(onUpdate=null, params=null) {
  var channel = new AreasChannel(onUpdate, params);
  channel.connect();
  return channel;
}

class AreasChannel extends Channel {
  constructor(onUpdate, params) {
    super("Reporting::AreasChannel", params);
    this.onUpdate = onUpdate ?? (()=>{});
  }

  received(data) {
    data.forEach(area => this.onUpdate(area));
  }
}
